module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.images.length == 1) ? _c('img', {
    staticClass: "partial-image",
    attrs: {
      "src": _vm.images[0],
      "alt": "image"
    }
  }) : (_vm.images.length > 1) ? _c('div', {
    staticClass: "slideshow"
  }, [_c('div', {
    staticClass: "slideshow__imagecontainer"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.currentImage,
    staticClass: "slideshow__image",
    attrs: {
      "src": _vm.currentImage
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next($event)
      }
    }
  })])], 1), _c('div', {
    staticClass: "slideshow__controls"
  }, [_c('a', {
    staticClass: "slideshow__previous",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previous($event)
      }
    }
  }, [_vm._v("prev")]), _c('span', {
    staticClass: "slideshow__indicator"
  }, [_vm._v(_vm._s(_vm.currentIndex + 1) + "/" + _vm._s(_vm.images.length))]), _c('a', {
    staticClass: "slideshow__next",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next($event)
      }
    }
  }, [_vm._v("next")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09f8cff2","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/partials/ImagePartial.vue
// module id = jgER
// module chunks = 1